import { FC, HTMLProps } from 'react';

export const LeftIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M9 4.5H19.5V6H9V4.5ZM9 9H16.5V10.5H9V9ZM9 13.5H19.5V15H9V13.5ZM9 18H16.5V19.5H9V18ZM4.5 3H6V21H4.5V3Z"
        fill="currentColor"
      />
    </svg>
  );
};
